import React from 'react';

function UserTerms() {
  return (
    <div style={{
      fontFamily: '"Nunito Sans", sans-serif',
      lineHeight: 1.6,
      color: '#333',
      backgroundColor: '#fff',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale'
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '50px 20px'
      }}>
        <div style={{
          margin: '50px 100px',
          marginBottom: 50
        }}>
          <h1 style={{
            textAlign: 'center',
            marginBottom: 30,
            fontSize: '2.5rem',
            fontWeight: 700,
            color: '#2c3e50'
          }}>用戶條款與細則</h1>
          
          <p style={{ marginBottom: 15, textAlign: 'justify' }}>
            在使用本應用程序之前，請仔細閱讀本條款及細則。這些條款告知閣下使用本應用程序[靜觀之道Mindful Gateway]的規則。
          </p>
          
          <div style={{ marginBottom: 30 }}>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>點擊以下連結即可查看更多詳情：</p>
            <ol style={{ marginLeft: 40, marginBottom: 20 }}>
              <li style={{ marginBottom: 5 }}><a href="#section1" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>關於我們以及如何聯絡我們。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section2" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>閣下使用本應用程序需要接受的條款。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section3" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>其他可能適用於閣下的條款。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section4" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們可能會修改的條款。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section5" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們可能會修改我們的服務内容。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section6" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們可能會暫停或撤銷我們的服務。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section7" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>閣下務必確保自己的帳戶資訊安全。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section8" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>閣下應如何使用本應用程序的資料。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section9" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>勿依賴本應用程序的資訊。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section10" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們對連結到的其他應用程序不承擔責任。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section11" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們不審核用戶生成的内容。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section12" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>如何投訢用戶上傳的內容。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section13" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>對於閣下遭受的損失或損害我們的責任範圍。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section14" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們如何使用閣下的個人資料。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section15" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>上傳内容到本應用程序。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section16" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>閣下授予我們使用閣下上傳的内容的權利。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section17" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們對電腦病毒免責，且禁止閣下引入病毒。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section18" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>關於連結到本應用程序的規則。</a></li>
              <li style={{ marginBottom: 5 }}><a href="#section19" style={{ color: '#2c3e50', fontWeight: 500, textDecoration: 'none' }}>我們適用哪個國家的法律解決爭議？</a></li>
            </ol>
          </div>

          <div style={{ marginBottom: 30 }} id="section1">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>1. 關於我們以及如何聯絡我們</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              靜觀之道應用程式（Mindful Gateway)為 (「我們」）營運的項目)。我們位於香港，隸屬於於香港中文大學敬霆靜觀研究與培訓中心。
            </p>
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: 20,
              borderRadius: 8,
              margin: '20px 0',
              borderLeft: '4px solid #007bff'
            }}>
              <p style={{ marginBottom: 15, textAlign: 'justify' }}>
                <strong>如需聯繫我們，請電郵至：</strong> cumindfulgateway@gmail.com
              </p>
            </div>
          </div>

          <div style={{ marginBottom: 30 }} id="section2">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>2. 閣下使用本應用程序需要接受的條款</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              通過使用本移動應用程式和/或服務即代表閣下接受並同意遵守這些使用條款。若閣下不同意這些條款，則無法使用我們的服務。我們建議閣下列印一份這些條款的副本以備將來參考。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section3">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>3. 其他可能適用於閣下的條款</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              當閣下使用我們的服務時，以下的附加條款也將適用於閣下：私隱政策。詳情請參閱《私隱政策》。我們的《可接受使用政策》，其中規定了我們應用程序的允許用途和禁止用途。使用本應用程序時，閣下必須遵守《可接受使用政策》。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section4">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>4. 我們可能會修改的條款</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們會不時修改這些條款。每當閣下希望使用我們的服務時，請閱覽這些條款以確保閣下了解當時適用的條款。這些條款最近更新於2025年8月1日。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section5">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>5. 我們可能會修改我們的服務内容</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們可能會依據我們的內容、用戶需求和項目重點的變化而不時更新或更改我們的服務內容。如有任何重大變化，我們將盡可能地向閣下發出合理通知。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section6">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>6. 我們可能會暫停或撤銷我們的服務</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              本應用程序是免費的。我們無法保證本應用程序或其中的任何內容始終保持可用或不中斷。出於業務、營運和資金原因，我們可能會暫停，撤銷，或限制本應用程序的全部或部分服務。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              如有任何暫停或撤銷我們將盡可能地向閣下發出合理通知。閣下亦有責任確保所有通過閣下的互聯網訪問本應用程序應用程序的人，都了解並遵守這些使用條款和其他適用的條款和條件。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section7">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>7. 閣下務必確保自己的帳戶資訊安全</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下選擇或接收到與我們安全程序相關的用戶識别碼、密碼或任何其他信息，閣下必須將此類信息視為機密資料，且不得將其透露給任何第三方。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若我們合理認為閣下未能遵守這些使用條款的任何規定，我們有權隨時禁用任何閣下已選擇或被分配的用戶識別碼或密碼。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下知道或懷疑除閣下以外的任何人知道閣下的用戶識別碼或密碼，閣下必須立即通過電郵cumindfulgateway@gmail.com通知我們。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section8">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>8. 閣下應如何使用本應用程序的資料</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們是本應用程序上所有知識產權權利及所有發佈内容的擁有人和被許可人。這些作品在全球範圍內受版權法和條約的保護。我們明確保留所有前述權利。閣下可以打印副本，也可以下載本應用程序上任何頁面的摘錄供閣下個人使用，閣下也可以提請閣下組織內的其他人注意本應用程序上發佈的內容。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下不得以任何方式修改閣下打印或下载的任何材料的列印或電子副本，且不得將任何插圖、照片、視頻或音頻序列或任何圖表與其隨附文本分開使用。閣下必須始終注明我們作為應用程序内容作者（以及任何已註明的貢獻者)的身份。若未經我們或我們的許可方授權，閣下不得將本應用程序上的任何内容用於商業目的。若閣下違反使用條款打印、複製、下載或使用我們應用程序的任何部分，我們將立即終止閣下使用本應用程序的權利，並保留追求法律責任的權利，閣下必須根據我們的選擇歸還或銷毁製作的所有内容副本，並減少影響和損害。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section9">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>9. 勿依賴本應用程序上的資訊</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              本應用程序上的內容僅供一般参考，閣下不應該依賴本應用程序所提供的建議。根據本應用程序上的內容採取或不採取任何行動之前，閣下必須獲得專業人士或專家的建議。儘管我們作出合理的努力及時地更新本應用程序上的信息，我們不明示或隱含地對本應用程序資料的準確性、完整性及適時性作出任何檐保或保證。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section10">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>10. 我們對連結至其他應用程序不承擔責任</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若本應用程序包含連接至第三方所提供的應用程序和資源，這些連結僅供閣下參考。此類連結不應被理解為我們保薦或認可從中所獲得的信息。我們無法控制這些應用程序或資源的內容。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section11">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>11. 我們不審核用戶生成的内容</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              本應用程序可能包含用戶上傳到本程序信息和内容。我們均不對這些資訊和内容進行核實或批准。用戶在本應用程序表達的觀點不代表我們的觀點或價值觀。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section12">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>12. 如何投訴用戶上傳的内容</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下想投訴用戶上傳的內容，請通過電郵cumindfulgateway@gmail.com與我們聯絡。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section13">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>13. 對於閣下遭受的損失或損害我們的責任範圍</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              <strong>無論閣下是消費者還是企業用戶：</strong>
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們不會違法的以任何方式限制或豁免我們需對閣下承擔的法律責任（包括因我們的疏忽或我們的員工、代理或分包商的疏忽以及欺詐，或欺詐性虛假陳述而造成的死亡或人身傷害的责任)。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              因向閣下提供任何產品而產生的責任將適用不同的責任限制和豁免。
            </p>
            
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 600,
              marginTop: 25,
              marginBottom: 10,
              color: '#2c3e50'
            }}>若閣下是企業用戶：</h3>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們排除所有可能適用於本應用程序或其任何內容的隱含條件、保證、聲明或其他條款。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們對於因下列原因引起或與之相關的任何損失或損害概不負責，無論是因合同、侵權(包括疏忽)、違反法定義務或其他原因（即使是可預見的)：
            </p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>使用或無法使用本應用程序；或者</li>
              <li style={{ marginBottom: 8 }}>使用或依賴本應用程序上顯示的任何內容。</li>
            </ul>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>尤其是，我們將對以下情況不承擔責任：</p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>利潤、銷售額、業務或收入的損失；</li>
              <li style={{ marginBottom: 8 }}>業務中斷；</li>
              <li style={{ marginBottom: 8 }}>預期储蓄損失；</li>
              <li style={{ marginBottom: 8 }}>商業機會、商譽或聲譽損失；或者</li>
              <li style={{ marginBottom: 8 }}>任何間接或摙帶損失或損害。</li>
            </ul>
            
            <h3 style={{
              fontSize: '1.2rem',
              fontWeight: 600,
              marginTop: 25,
              marginBottom: 10,
              color: '#2c3e50'
            }}>若閣下是消費者用戶：</h3>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              請注意，本應用程序僅供家庭和私人使用。閣下同意不出於任何商業或商務目的而使用本應用程序，我們不會對閣下的任何利潤損失、業務損失、業務中斷或商業機會損失承擔任何責任。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section14">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>14. 我們如何使用閣下的個人資料</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們只會按照我們的私隱政策隱私政策中的規定使用閣下的個人資料。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section15">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>15. 上傳內容到本應用程序</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              當閣下使用上傳功能把內容上傳到本應用程序，或與本應用程序其他用戶聯繫的功能時，閣下必須遵守我們的《可接受使用政策》中的規定。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下保證任何此類上傳内容確實符合這些標準，且閣下將就任何違反該保證的行為向我們承擔責任並作出賠償。這意味著閣下將對我們因此而遭受的任何損失或損害負責。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下上傳到本應用程序的任何內容都將被視為非機密和非專有內容。閣下將保留對上傳内容的擁有權，但閣下必須授予我們和本應用程序的其他用戶有限的許可,以使用、存儲和複製該内容,以及分發和提供該內容給第三方。任何第三方聲稱閣下所發佈或上傳到本應用程序的任何内容構成侵犯知識產權或隱私權的，我們有權向其披露閣下身份。我們有權删除任何我們認為不符合我們的《可接受使用政策》規定，閣下在本應用程序上發佈的內容。閣下將自行負責保護和備份閣下的内容。我們不存储恐怖主義内容。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section16">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>16. 閣下授予我們使用閣下上傳的内容的權利</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              當閣下將内容上傳或發佈到本應用程序時，閣下授予我們如下使用該內容的權利：
            </p>
            <ul style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>全球性、非專有、免版稅、可轉讓的許可，用於跨媒體使用、複製、分發、展示和演出。</li>
              <li style={{ marginBottom: 8 }}>與應用程序提供的服務相關的用戶生成内容及製作其衍生作品，包括用於推廣應用程序及服務；有效至用戶從應用程序上删除內容爲止，或永久有效；</li>
              <li style={{ marginBottom: 8 }}>全球性、非專有、免版稅、可轉讓的許可，供其他用戶、合作夥伴或廣告商根據其目的或根據應用程序功能使用其内容；有效至用戶從應用程序上删除内容爲止，或永久有效。</li>
            </ul>
          </div>

          <div style={{ marginBottom: 30 }} id="section17">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>17. 我們對電腦病毒免責，且禁止閣下引入病毒</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              我們無法保證本應用程序始終是安全、沒有漏洞或電腦病毒的。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下有責任自行配置通訊網絡、電腦程式和平台以瀏覽本應用程序。閣下應該使用自己的病毒防護軟件。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下不得濫用本應用程序，故意引入電腦病毒、木馬程式、電腦蠕蟲丶邏輯炸彈或其他惡意程式或有害數據。閣下未經授權不得試圖訪問本應用程序、存儲本應用程序的伺服器或連接到本應用程序的任何伺服器、電腦或數據庫。閣下不得通過阻斷服務攻擊或分散式阻斷服務攻擊，以攻擊本應用程序。根據《刑事罪行條例》，違反此規定即構成刑事犯罪。我們將向相關執法機構報告任何此類違規行為，並與有關部門合作，向他們披露閣下的身份。若發生此類違規行為，我們將立即終止閣下使用本應用程序的權利。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section18">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>18. 關於連結到本應用程序的規則</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              唯使用公正合法，且不會損害或利用我們聲譽的方式，且經我們同意後，閣下方可以連結到我們的应用。閣下不得以暗示與我們有根本不存在的任何形式的關聯、批准或認可的方式建立連結。閣下不得在不屬於閣下的任何應用程序上建立本應用程序的連結。本應用程序不得在任何其他應用程序的框架內顯示，閣下亦不得建立連結到本應用程序主頁以外的任何部分。我們保留撤銷連結許可的權利，恕不另行通知。閣下連結的應用程序，必須事先獲得同意並在所有方面皆符合我們的《可接受使用政策》之規定。
            </p>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下希連結至或使用本應用程序内除上述內容以外的任何内容，請電郵至cumindfulgateway@gmail.com。
            </p>
          </div>

          <div style={{ marginBottom: 30 }} id="section19">
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>19. 我們適用哪個國家的法律解決爭議？</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              若閣下是消費者，請注意這些使用條款、其主題内容及其訂立均受香港法律管轄。閣下和我們皆同意香港法院將擁有專屬管轄權。若閣下是一家企業，則這些使用條款、其主题內内容及其钉立（以及任何非合同糾紛或索賠）均受香港法律管轄。我們雙方同意香港法院擁有專屬管轄權。
            </p>
          </div>

          <div style={{ marginBottom: 30 }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 600,
              marginTop: 30,
              marginBottom: 15,
              color: '#34495e'
            }}>《可接受使用政策》</h2>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              作為服務條款的一部分，閣下同意不濫用或幫助其他任何人濫用我們的服務（「服務」)。例如，閣下同意不對我們的项目進行以下任何行動：
            </p>
            <ol style={{ marginLeft: 40, marginBottom: 15 }}>
              <li style={{ marginBottom: 8 }}>將我們的服務/項目用於非法或未經授權的目的；</li>
              <li style={{ marginBottom: 8 }}>使用我們的服務/項目時使用的實體不是以其名義註冊的業務實體；</li>
              <li style={{ marginBottom: 8 }}>轉售閣下獲得許可權的任何文件；</li>
              <li style={{ marginBottom: 8 }}>轉售或試圖以商業方式從屬於項目一部分的任何可用内容中獲利；</li>
              <li style={{ marginBottom: 8 }}>有系統地生成或下載商業上危害本項目的文件；</li>
              <li style={{ marginBottom: 8 }}>出售服務/項目，除非獲得特别授權；</li>
              <li style={{ marginBottom: 8 }}>探測、掃描或測試任何系統或網絡的漏洞；</li>
              <li style={{ marginBottom: 8 }}>違反或以其他方式規避任何安全或認證措施；</li>
              <li style={{ marginBottom: 8 }}>訪間、篡改或使用服務/項目的非公共區域或閣下未受邀參加的服務/項目部分的共享區域；</li>
              <li style={{ marginBottom: 8 }}>干擾或干預任何用戶、主機或網絡，例如通過發送病毒，木馬，蠕蟲，邏輯炸彈或其他惡意的或技術上有害的材料，超載，氾濫，垃圾郵件，郵件轟炸平台或服務，或腳本創建的内容，以干擾或製造對平台或服務不必要的負擔；</li>
              <li style={{ marginBottom: 8 }}>通過或嘗試通過我們公開支援的界面以外的任何方式（自動或其他方式）訪間、搜索或創建服務/項目帳戶（例如，網頁抓取或批量創建帳戶)；</li>
              <li style={{ marginBottom: 8 }}>發送未經索取的通信、促銷或廣告或垃圾郵件；</li>
              <li style={{ marginBottom: 8 }}>偽造任何電子郵件中的任何TCP/IP數據包標頭或標頭信息的任何部分；</li>
              <li style={{ marginBottom: 8 }}>發送修改的，欺騙性的或虛假的源識別信息，包括「欺騵攻擊」或「網絡釣魚」；</li>
              <li style={{ marginBottom: 8 }}>未經適當授權進行調查、競賽或傳銷，或推廣或宣傳產品或服務；</li>
              <li style={{ marginBottom: 8 }}>濫用推薦或促銷；</li>
              <li style={{ marginBottom: 8 }}>轉載、發佈、上傳、展示、分發或共享非法、不當、粗俗、色情、淫穢、不雅、誹謗性、毁謗性、辱罵性或故意虚假和/或侵犯知識產權的内容；</li>
              <li style={{ marginBottom: 8 }}>違反我們服務條款的文本或精神；</li>
              <li style={{ marginBottom: 8 }}>以任何方式違反適用的法律或法規；或者</li>
              <li style={{ marginBottom: 8 }}>侵犯他人的隱私或權利。</li>
            </ol>
            <p style={{ marginBottom: 15, textAlign: 'justify' }}>
              閣下承認以上並非盡列清單。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserTerms;
